import type { LineItemList, Nullable } from '../../../../../models';

export const getUniqueCountriesString = (lineItemList?: Nullable<LineItemList[]>): string => {
  const countryList = new Set<string>();

  lineItemList?.forEach((lineItem) => {
    lineItem?.countries?.forEach((code) => {
      if (code) {
        countryList.add(code);
      }
    });
  });

  return Array.from(countryList).join(', ');
};
